import { memo } from 'react'
import Styles from './Image.module.scss'
import cx from 'classnames'
import { optimizedImageUrlString } from '../../utils'

interface Props {
  src: string
  alt: string
  size?: number
  blurred?: boolean
  className?: string
}

const Image = ({ src, alt, blurred = false, className, size }: Props) => {
  const url = optimizedImageUrlString(src, size ? (size * 2).toString() : undefined)
  return <img alt={alt} src={url} className={cx(Styles.image, className, { [Styles.blurred]: blurred })} />
}

const MemoizedImage = memo(Image)

export { MemoizedImage as Image }
